import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../API/axiosNeatex';
import type { APIResponse } from '@store/Shared/shared';

export interface ProjectIncident {
  id: string;
  organizationId: string;
  incidentType: string;
  name: string;
  name2: string;
  description: string;
  statusId: string;
  reportedBy: string;

  reportedNumber: null;
  reportedName: string;
  reportedName2: string;
  reportedDate: string;
  impactDescription: string;
  isAme: boolean;
  ameStatus: number;
}

export const addProjectIncident = createAsyncThunk(
  'Project/addProjectIncident',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post<APIResponse<string>>('Project/AddProjectIncident', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateProjectIncidentStatus = createAsyncThunk(
  'Project/updateProjectIncidentStatus',
  async (item: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('Project/UpdateProjectIncidentStatus', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getProjectIncidentList = createAsyncThunk(
  'Project/getProjectIncidentList',
  async (projectId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('Project/GetProjectIncidentListByProjectId', {
        params: { organizationId: projectId }
      });
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  incidents: ProjectIncident[];
  previousIncidents: ProjectIncident[];
  loading: boolean;
  error: any | null;
} = {
  incidents: [],
  previousIncidents: [],
  loading: false,
  error: null
};

const projectIncidentSlice = createSlice({
  name: 'ProjectIncident',
  initialState,
  reducers: {
    updateIncidentInList: (state, action: PayloadAction<{ incidentId: string; updates: Partial<ProjectIncident> }>) => {
      const { incidentId, updates } = action.payload;
      const idx = state.incidents.findIndex(i => String(i.id) === String(incidentId));
      if (idx !== -1) {
        state.incidents[idx] = { ...state.incidents[idx], ...updates };
      }
    },
    rollbackIncidents: state => {
      state.incidents = state.previousIncidents;
    }
  },
  extraReducers(builder) {
    // يمكن إضافة extra reducers للحالات الأخرى إذا كانت هناك APIs للحصول على البيانات
    builder
      .addCase(getProjectIncidentList.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getProjectIncidentList.fulfilled, (state, action) => {
        state.loading = false;
        state.incidents = action.payload.data;
      })
      .addCase(getProjectIncidentList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { updateIncidentInList, rollbackIncidents } = projectIncidentSlice.actions;
export default projectIncidentSlice.reducer;
